import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Page from "src/layouts/Page";
import ContentTable, {
	ContentTableItem,
	ContentTableColumn
} from "src/components/ContentTable/ContentTable";
import { ConfirmationModal } from "src/modals/ConfirmationModal/ConfirmationModal";
import useAdminHashtags from "../../hooks/useAdminHashtags";
import useDeleteHashtag from "../../hooks/useDeleteHashtag";
import { mapHashtagsToContentTableItems } from "../../utils/mapHashtagsToContentTableItems";

const hashtagColumns: ContentTableColumn[] = [
	{
		key: "color",
		label: "Colour",
		width: "80px",
		render: (item) => {
			const color = (item.data?.color as string) || "#ccc";
			return (
				<span
					className="inline-block w-5 h-5 rounded-full border border-border"
					style={{ backgroundColor: color }}
					title={color}
				>
					<span className="sr-only">{color}</span>
				</span>
			);
		}
	},
	{
		key: "isPrivate",
		label: "Private",
		render: (item) => (item.data?.isPrivate ? "Yes" : "No")
	},
	{
		key: "isFavourite",
		label: "Favourite",
		render: (item) => (item.data?.isFavourite ? "Yes" : "No")
	}
];

const Hashtags = () => {
	const navigate = useNavigate();
	const [itemToDelete, setItemToDelete] = useState<ContentTableItem | null>(
		null
	);

	const { data: allHashtags = [] } = useAdminHashtags();
	const { mutate: deleteHashtag, isLoading: isDeleting } = useDeleteHashtag();

	const items = mapHashtagsToContentTableItems(allHashtags);

	return (
		<Page>
			<ContentTable
				items={items}
				columns={hashtagColumns}
				showCreatedBy={false}
				showLastUpdated={false}
				showOrder={false}
				showStatus={false}
				onRowClick={(item) => navigate(`/social-feed/hashtags/${item.id}`)}
				onDelete={(item) => setItemToDelete(item)}
				createPath="/social-feed/hashtags/create"
				createLabel="Create Hashtag"
			/>

			<ConfirmationModal
				isOpen={itemToDelete !== null}
				title="Delete hashtag?"
				description="This action cannot be undone."
				onCancel={() => {
					if (!isDeleting) setItemToDelete(null);
				}}
				cancelBtnProps={{ disabled: isDeleting }}
				onSubmit={() => {
					if (itemToDelete) {
						deleteHashtag(String(itemToDelete.id), {
							onSuccess: () => setItemToDelete(null)
						});
					}
				}}
				submitBtnProps={{ isLoading: isDeleting }}
			/>
		</Page>
	);
};

export default Hashtags;
